export default __webpack_public_path__ + "static/media/ic_payment_selected.a8683bd8.svg";